import React from "react";
import { Star, CheckCircle2 } from "lucide-react";
import { IMAGES } from "../lib/business";

export default function TrustSection() {
  return (
    <section
      data-testid="trust-section"
      className="bg-[#0A0A0A] py-16 md:py-24 border-b border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block bg-[#E50914] px-3 py-1 mb-4">
              <span className="font-anton text-sm uppercase tracking-widest text-white">
                Confiança na Estrada
              </span>
            </div>
            <h2 className="font-anton text-4xl md:text-6xl uppercase text-white leading-[0.95] mb-6">
              Mais de <span className="text-[#E50914]">1.000</span>
              <br />
              Atendimentos Realizados
            </h2>
            <p className="font-work text-lg text-zinc-300 mb-8 leading-relaxed">
              Na hora do aperto você precisa de quem realmente atende. A Refúgio Guincho oferece socorro rápido, preço acessível e total cuidado com seu veículo — do carro popular ao de luxo, passando por motos, camionetes e utilitários.
            </p>

            {/* Rating */}
            <div className="flex items-center gap-4 mb-8">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-6 h-6 fill-[#E50914] text-[#E50914]" />
                ))}
              </div>
              <div>
                <div className="font-anton text-2xl text-white">5.0 / 5.0</div>
                <div className="font-work text-xs text-zinc-400 uppercase tracking-wider">
                  187+ avaliações de clientes
                </div>
              </div>
            </div>

            <ul className="space-y-3">
              {[
                "Equipe treinada e com experiência",
                "Transparência total no orçamento",
                "Atendimento humanizado em momento de stress",
                "Centro automotivo próprio para manutenção",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#E50914] shrink-0 mt-0.5" strokeWidth={2.5} />
                  <span className="font-work text-zinc-200">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Image grid */}
          <div className="grid grid-cols-2 gap-3 md:gap-4">
            <div className="col-span-2 relative overflow-hidden hover-lift border-2 border-zinc-800 hover:border-[#E50914]">
              <img
                src={IMAGES.autoCenter}
                alt="Caminhão Refúgio Guincho em frente ao Centro Automotivo em Araçoiaba da Serra"
                className="w-full h-56 md:h-72 object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 bg-[#E50914] text-white px-3 py-1 font-anton text-sm uppercase tracking-wider">
                Centro Automotivo Próprio
              </div>
            </div>
            <div className="relative overflow-hidden hover-lift border-2 border-zinc-800 hover:border-[#E50914]">
              <img
                src={IMAGES.porsche}
                alt="Transporte de Porsche esportivo preto em caminhão guincho"
                className="w-full h-48 md:h-56 object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 bg-black/90 text-white px-3 py-1 font-anton text-xs uppercase tracking-wider">
                Carro de Luxo
              </div>
            </div>
            <div className="relative overflow-hidden hover-lift border-2 border-zinc-800 hover:border-[#E50914]">
              <img
                src={IMAGES.heroTruckRain}
                alt="Caminhão guincho Refúgio atendimento 24h em qualquer clima"
                className="w-full h-48 md:h-56 object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 bg-black/90 text-white px-3 py-1 font-anton text-xs uppercase tracking-wider">
                Atendimento 24h
              </div>
            </div>
          </div>
        </div>

        {/* Stats row */}
        <div className="mt-16 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 border-y-2 border-[#E50914] py-8">
          {[
            { n: "1000+", l: "Atendimentos" },
            { n: "24h", l: "Sempre on-line" },
            { n: "9+", l: "Cidades atendidas" },
            { n: "100%", l: "Foco no cliente" },
          ].map((s) => (
            <div key={s.l} className="text-center">
              <div className="font-anton text-4xl md:text-6xl text-[#E50914] uppercase leading-none">
                {s.n}
              </div>
              <div className="font-work text-xs md:text-sm text-zinc-300 uppercase tracking-widest mt-2 font-bold">
                {s.l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
